export default "__VITE_ASSET__Ctk1a1IL__"